import { useEffect, useState } from "react";
import api from "@/lib/api";

/** iter447 pt 3 — tableaux de bord autorisés (cartes) de l'utilisateur ; 0 carte = onglet masqué. Cache mémoire, rafraîchi sur « rights:changed ». */
let cache = null;
export function useDashboardAccess() {
  const [d, setD] = useState(cache);
  useEffect(() => {
    const load = () => api.get("/me/dashboards").then(({ data }) => { cache = data.dashboards || {}; setD(cache); }).catch(() => {});
    if (!cache) load();
    window.addEventListener("rights:changed", load);
    return () => window.removeEventListener("rights:changed", load);
  }, []);
  return (dash) => !d || ((d[dash]?.cards || []).length > 0);
}
